import { ID } from './id';

export enum ReminderBasedOn {
  Start = 'start',
  DayStart = 'dayStart',
}

export type Reminder = {
  id?: ID | null;
  offset: number;
  basedOn: ReminderBasedOn;
};
